import { render, staticRenderFns } from "./HelloUser.vue?vue&type=template&id=1060b840&scoped=true"
import script from "./HelloUser.vue?vue&type=script&lang=ts"
export * from "./HelloUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1060b840",
  null
  
)

export default component.exports